﻿/*
 * Globalize Culture pt-BR
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("pt-BR", "default", {
    name: "pt-BR",
    englishName: "Portuguese (Brazil)",
    nativeName: "Português (Brasil)",
    language: "pt",
    numberFormat: {
      ",": ".",
      ".": ",",
      NaN: "NaN (Não é um número)",
      negativeInfinity: "-Infinito",
      positiveInfinity: "+Infinito",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-$ n", "$ n"],
        ",": ".",
        ".": ",",
        symbol: "R$"
      }
    },
    calendars: {
      standard: {
        days: {
          names: [
            "domingo",
            "segunda-feira",
            "terça-feira",
            "quarta-feira",
            "quinta-feira",
            "sexta-feira",
            "sábado"
          ],
          namesAbbr: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
          namesShort: ["D", "S", "T", "Q", "Q", "S", "S"]
        },
        months: {
          names: [
            "janeiro",
            "fevereiro",
            "março",
            "abril",
            "maio",
            "junho",
            "julho",
            "agosto",
            "setembro",
            "outubro",
            "novembro",
            "dezembro",
            ""
          ],
          namesAbbr: [
            "jan",
            "fev",
            "mar",
            "abr",
            "mai",
            "jun",
            "jul",
            "ago",
            "set",
            "out",
            "nov",
            "dez",
            ""
          ]
        },
        AM: null,
        PM: null,
        eras: [{ name: "d.C.", start: null, offset: 0 }],
        patterns: {
          d: "dd/MM/yyyy",
          D: "dddd, d' de 'MMMM' de 'yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dddd, d' de 'MMMM' de 'yyyy HH:mm",
          F: "dddd, d' de 'MMMM' de 'yyyy HH:mm:ss",
          M: "dd' de 'MMMM",
          Y: "MMMM' de 'yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Ajuda adicional",
      AddNewTab: "Adicionar nova guia",
      Alerts: "Alertas",
      ApplyFilter: "Aplicar filtro",
      Approve: "Aprovar",
      Attachments: "Anexos",
      Back: "Voltar",
      Basic: "Básico",
      Between: "Entre",
      Book: "Livro",
      Cancel: "Cancelar",
      Checked: "Verificado",
      ClearFilter: "Limpar filtro",
      Close: "Fechar",
      CloseCancelChanges: "Fechar e cancelar alterações",
      CloseSaveChanges: "Fechar e salvar alterações",
      CloseTab: "Fechar guia",
      ColumnPersonalization: "Personalização de coluna",
      Comments: "Comentários",
      Confirmation: "Confirmação",
      Contains: "Contém",
      CreateTab: "Criar uma nova guia",
      Cut: "Cortar",
      Delete: "Excluir",
      DiscardUndo: "Descartar/Desfazer",
      DisplayDropDownList: "Exibir lista suspensa",
      Displaying: "Exibindo: ",
      DocWord: "Documento",
      DoesNotContain: "Não contém",
      DoesNotEndWith: "Não termina com",
      DoesNotEqual: "Não é igual à",
      DoesNotStartWith: "Não começa com",
      Download: "Fazer download",
      Duplicate: "Duplicar",
      Edit: "Editar",
      EitherSelectedorNotSelected: "Selecionado ou não selecionado",
      Email: "Email",
      EndsWith: "Termina com",
      EqualsStr: "É igual a",
      ExpandCollapse: "Expandir/Recolher",
      ExportFailed: "Falha na Exportação",
      ExportToExcel: "Exportar para Excel",
      FileInUse: "O arquivo especificado está em uso",
      FileInUseDetail:
        "Feche o arquivo no aplicativo onde está sendo usado ou especifique um outro nome de arquivo.",
      Filter: "Filtro",
      FilterMenu: "Menu Filtro",
      FilterOptions: "Opções de filtro",
      FilterWithinResults: "Filtro nos resultados",
      First: "Primeiro",
      FirstView: "Primeira visualização",
      Folder: "Pasta",
      ForgotPassword: "Esqueceu a senha?",
      Forward: "Encaminhar",
      GetMoreRows: "Obter mais linhas",
      GreaterThan: "É maior que",
      GreaterThanOrEquals: "É maior que ou igual à",
      GridSettings: "Configurações de grade",
      GroupSelection: "Seleção de grupo",
      Help: "Ajuda",
      HideColumn: "Ocultar coluna",
      IsEmpty: "Está vazio",
      IsNotEmpty: "Não está vazio",
      Last: "Último",
      LastView: "Última visualização",
      LaunchActivate: "Iniciar/Ativar",
      LessThan: "É menor que",
      LessThanOrEquals: "É menor que ou igual à",
      Links: "Links",
      ListTabs: "Listar todas as guias",
      LoadingItem: "Carregando item ",
      Maintenance: "Manutenção",
      Menu: "Menu",
      New: "Novo",
      Next: "Próximo",
      NextView: "Próxima visualização",
      No: "Não",
      NotChecked: "Não verificado",
      Notes: "Notas",
      NotSelected: "Não selecionado",
      Of: " de ",
      Ok: "OK",
      Open: "Abrir",
      Password: "Senha",
      Paste: "Colar",
      Phone: "Telefone",
      PleaseWait: "Aguarde",
      Previous: "Anterior",
      PreviousView: "Visualização anterior",
      Print: "Imprimir",
      Queries: "Consultas",
      Redo: "Refazer",
      Refresh: "Atualizar",
      Reject: "Rejeitar",
      RememberMe: "Lembrar de mim neste computador",
      Reports: "Relatórios",
      Reset: "Redefinir",
      Review: "Revisar",
      RunFilter: "Executar filtro",
      RunJob: "Executar trabalho",
      Save: "Salvar",
      SaveBeforeClosing: "Salvar antes de fechar",
      SavedFilters: "Filtros salvos",
      SaveSubmit: "Salvar/Enviar",
      ScreenDesign: "Design de tela",
      Search: "Buscar",
      SelectContents: "Selecionar conteúdo",
      SelectDate: "Selecionar uma data",
      SelectDeselect: "Selecionar/Deselecionar todos",
      Selected: "Selecionado: ",
      ServerName: "Nome do servidor",
      Settings: "Configurações",
      ShowFilterRow: "Mostrar linha de filtro",
      SignIn: "Conectar",
      SortAscending: "Classificação ascendente",
      SortDescending: "Classificação descendente",
      Spreadsheet: "Planilha",
      StartsWith: "Começa com",
      StatusIndicator: "Indicador de status",
      Tasks: "Tarefas",
      Today: "Hoje",
      Translate: "Traduzir",
      UserID: "ID de usuário",
      Utilities: "Utilitários",
      Yes: "Sim",
      Page: "Página",
      Rows: "Linhas",
      ShowingAll: "Mostrando tudo",
      SessionNavigation: "Navegação de sessão",
      ListAllMenuItems: "Listar todos os itens de menu",
      NoRecordsFound: "Nenhum registro encontrado",
      SearchTree: "Árvore de pesquisa",
      Clear: "Limpar",
      DrillDown: "Busca detalhada",
      Required: "Este é um campo obrigatório",
      Available: "Disponível:",
      Add: "Adicionar",
      MoveDown: "Mover para baixo",
      MoveUp: "Mover para cima",
      Remove: "Remover",
      LastYear: "Último ano",
      NextMonth: "Próximo mês",
      NextWeek: "Próxima semana",
      NextYear: "Próximo ano",
      OneMonthAgo: "Um mês atrás",
      OneWeekAgo: "Uma semana atrás",
      SixMonthsAgo: "Seis meses atrás",
      Time: "Hora",
      CannotBeSelected: "Esta linha não pode ser selecionada.",
      ResetToDefault: "Redefinir para layout padrão.",
      CloseOtherTabs: "Fechar outras guias",
      EmailValidation: "Insira um endereço de e-mail válido",
      UrlValidation: "Insira uma URL válida",
      EndofResults: "Fim de resultados",
      More: "Mais...",
      RecordsPerPage: "Registros por página",
      Maximize: "Maximizar",
      Minimize: "Minimizar",
      CloseAllTabs: "Fechar todas as guias",
      QuickDates: "Quick Dates",
      Finish: "Concluir",
      SetTextColor: "Definir cor do texto",
      AttachmentRules: "Regras de anexo",
      AutoRefresh: "Atualização automática",
      BarChart: "Gráfico de barras",
      CopyMail: "Copiar e enviar por e-mail",
      CopyUrl: "Copira Url",
      DistributeHorizontally: "Distribuir horizontalmente",
      ExpandAll: "Expandir tudo",
      Generate: "Gerar",
      GenerateScript: "Gerar script",
      NoAttachments: "Sem anexos",
      PieChart: "Gráfico de pizza",
      QuickAccess: "Acesso rápido",
      RestoreUser: "Restaurar usuário",
      SaveConsolidate: "Salvar com consolidação local",
      "Screen Design": "Design da tela",
      SelectAll: "Selecionar tudo",
      SpellCheck: "Corretor ortográfico",
      SubmitForApproval: "Enviar para aprovação",
      TopDownSpread: "Top Down Spread",
      Timezone: "Fuso horário",
      Loading: "Carregando...",
      NewNode: "Novo nó"
    }
  });
})(this);
